export default "__VITE_ASSET__p5zgiYt0__"